<style lang="less" scoped>
.product-coupon{
  background-color: #fff;
  padding: 0 16px;
  .product-main{
    display: flex;
    align-items: center;
    padding: 16px 0;
    .coupon-value{
      flex: 1;
      height: 100%;
      padding-right: 16px;
      .value{
        font-size: 28px;
        color: #ff5000;
        text-align: center;
        font-weight: 500;
        line-height: 40px;
      }
      .limitation{
        font-size: 13px;
        text-align: center;
        color: #4a4a4a;
      }
    }
    .coupon-info{
      border-left: 1px dotted #d2d2d2;
      flex: 2;
      padding-left: 27px;
      position: relative;
      .coupon-name{
        font-weight: 500;
        font-size: 17px;
        color: #000;
        margin-bottom: 4px;
        line-height: 24px;
      }
      .coupon-end-time{
        font-size: 13px;
        color: #4a4a4a;
        margin-bottom: 10px;
      }
      .coupon-desc{
        background-color: #d29d5f;
        color: #fff;
        font-size: 10px;
        border-radius: 3.4px;
        display: inline-block;
        padding: 4px 6px;
      }
      .coupon-num{
        position: absolute;
        right: 0;
        bottom: 0;
        font-size: 13px;
        color: #4a4a4a;
      }
    }
  }
  .dividing-line{
    height: 0.5px;
    background-color: #d2d2d2;
  }
  .product-num-contrl{
    height: 57.5px;
    font-size: #4a4a4a;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>

<template>
  <div class="product-coupon">
    <div class="product-main">
      <div class="coupon-value">
        <div class="value">{{ couponDiscount }}</div>
        <div class="limitation">{{ useLimit }}</div>
      </div>
      <div class="coupon-info">
        <div class="coupon-name">{{ coupon.title}}</div>
        <div class="coupon-end-time" v-if="coupon.endTime">{{ coupon.endTime | time }}到期</div>
        <div class="coupon-desc" v-if="coupon.label">{{ coupon.label }}</div>
        <div class="coupon-num">X {{ buyNumber }}</div>
      </div>
    </div>
    <div class="dividing-line"></div>
    <div class="product-num-contrl">
      <label>购买数量：</label>
      <num-control
        :limitMaxNum="limitMaxNumber"
        :limitMinNum="limitMinNumber"
        @num-add="addNumber"
        @num-reduce="reduceNumber"
      ></num-control>
    </div>
    <div class="product-price"></div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import numControl from './number_control.vue'
import { priceConversion } from '../../../util/function.js'
import op from 'object-path'

export default {
  props: ['activeCode', 'activeDetail'],
  data() {
    return {
      buyNumber: 0,
      coupon: {
        title: '',
        label: '',
        endTime: '',
        discountAmount: 0,
        limitAmount: 0,
      },

    }
  },
  components: {
    numControl,
  },
  computed: {
    couponDiscount() {
      return `${priceConversion(this.coupon.discountAmount)}元`
    },
    useLimit() {
      return this.limitAmount ? `消费满${priceConversion(this.limitAmount)}元可用` : '无使用门槛'
    },
    needPay() {
      return this.singlePrice * this.buyNumber
    },
    limitMinNumber() {
      return op(this.activeDetail).get('minCountPerOrder') || 1
    },
    limitMaxNumber() {
      return op(this.activeDetail).get('maxCountPerOrder') || 2
    },
    singlePrice() {
      return op(this.activeDetail).get('productInfo.skuList.0.price') || 0
    },
    skuInfo() {
      return op(this.activeDetail).get('productInfo.skuList.0') || {}
    },
  },
  methods: {
    addNumber(){
      console.log(1)
    },
    reduceNumber(){
      console.log(2)
    },
    ...mapActions([

      'getCouponDetailforSale',
    ]),
    addNumber(buyNumber) {
      this.buyNumber = buyNumber
    },
    reduceNumber(buyNumber) {
      this.buyNumber = buyNumber
    },
  },
  async mounted() {
    this.buyNumber = this.limitMinNumber

    this.getCouponDetailforSale({
      activeCode: this.activeCode,
    }).then(data => {
      this.coupon = data.coupon
    })
  },
  watch: {
    limitMinNumber(newVal) {
      this.buyNumber = newVal
    },
    needPay(newVal) {
      this.$store.commit('setTotalPrice', newVal)
    },
    skuInfo(newVal) {
      this.$store.commit('setSkuListData', [{
        skuId: this.skuInfo.skuId,
        price: this.skuInfo.price,
        count: this.buyNumber,
      }])
    },
    buyNumber(newVal) {
      this.$store.commit('setSkuListData', [{
        skuId: this.skuInfo.skuId,
        price: this.skuInfo.price,
        count: this.buyNumber,
      }])
    }
  }
}
</script>
